import { Helmet } from 'react-helmet-async';
// @mui
import {
    Button,
    Container,
    FormControl,
    FormControlLabel,
    Grid,
    Radio,
    RadioGroup,
    Stack,
    Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';
// components
import Iconify from '../../components/iconify';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// sections
import { useMemo, useRef, useState } from 'react';
import { useDownloadExcel } from 'react-export-table-to-excel';
import { useTranslation } from 'react-i18next';
import { glb_sv } from 'src/utils';

import moment from 'moment';
import { Link as RouterLink, useParams } from 'react-router-dom';
import Breadcrumb from 'src/components/Breadcrumb/Breadcrumb';
import DatePickerValue from 'src/components/Input/DatePickerValue';
import SelectObjectDepartment from 'src/components/select-object/SelectDepartment';
import crypt from 'src/utils/service/crypt';
import AmountTotal from './expense-amount-detail';
import ExpenseTotal from './expense-amount-total';
import ExpenseAndAmountByTime from './expense-and-amount-by-time';
import Loader from 'src/components/loader/loader';

// ---------------------------------------------------------------------

const StyledTitle = styled('div')(({ theme }) => ({
    fontSize: '30px', // Cỡ chữ mặc định
    [theme.breakpoints.down('md')]: {
        fontSize: '27px', // Cỡ chữ cho màn hình trung bình
    },
    [theme.breakpoints.down('sm')]: {
        fontSize: '18px', // Cỡ chữ cho màn hình nhỏ
    },
    [theme.breakpoints.down('xs')]: {
        fontSize: '16px', // Cỡ chữ cho màn hình rất nhỏ
    },
}));
const StyledSubheader = styled('div')(({ theme }) => ({
    fontSize: '23px', // Cỡ chữ mặc định
    [theme.breakpoints.down('md')]: {
        fontSize: '25px', // Cỡ chữ cho màn hình trung bình
    },
    [theme.breakpoints.down('sm')]: {
        fontSize: '16px', // Cỡ chữ cho màn hình nhỏ
    },
    [theme.breakpoints.down('xs')]: {
        fontSize: '14px', // Cỡ chữ cho màn hình rất nhỏ
    },
}));
export default function ExportReport() {
    const params = useParams();
    const [getFlags, setGetFlags] = useState(false);
    const [startDay, setstartDay] = useState(moment().startOf('month').format('YYYYMMDD'));
    const [toDay, settoDay] = useState(moment().format('YYYYMMDD'));

    const { t } = useTranslation();

    const [selectedValue, setSelectedValue] = useState('one');

    const tableRef = useRef(null);

    const [department, setDepartment] = useState(null);
    const userRef = useRef(null);
    useMemo(() => {
        try {
            userRef.current = JSON.parse(crypt.deCode(sessionStorage.getItem('proc_data')));
            if (userRef.current?.group_user === '3') {
                const valueDepartement = {
                    id: userRef.current?.department_id || 0,
                    departs_nm: userRef.current?.departs_nm || '',
                };
                setDepartment(valueDepartement);
            }
        } catch (error) {}
    }, []);

    const { onDownload } = useDownloadExcel({
        currentTableRef: tableRef.current,
        filename:
            selectedValue === 'one'
                ? `${t('xuat_bao_cao')} ${glb_sv.formatDate(
                      startDay,
                      'YYYYMMDDHHmmss',
                      'DD_MM_YYYY'
                  )} - ${glb_sv.formatDate(toDay, 'YYYYMMDDHHmmss', 'DD_MM_YYYY')}`
                : `${t('xuat_bao_cao_3_month')}`,
        sheet: t('xuat_bao_cao'),
    });

    const handleChange = (event) => {
        setSelectedValue(event.target.value);
    };

    return (
        <>
            <Helmet>
                <title> {t('xuat_bao_cao')} </title>
            </Helmet>
            <Loader loading={getFlags} />

            <Container maxWidth="xl">
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
                    <Typography variant="h5" sx={{ mb: 0 }}>
                        {t('xuat_bao_cao')}
                    </Typography>
                    <Stack spacing={1} direction="row" alignItems="center" justifyContent="space-between">
                        <Button
                            variant="contained"
                            startIcon={<Iconify icon="material-symbols:event-note-outline" />}
                            to={`/home/export-report/${params.idPermission}/export-ware-house/`}
                            component={RouterLink}
                        >
                            {t('export_ware_house')}
                        </Button>{' '}
                        <Button variant="contained" startIcon={<Iconify icon="ei:share-apple" />} onClick={onDownload}>
                            {t('export_excel')}
                        </Button>
                    </Stack>
                </Stack>
                <Breadcrumb paths={[{ label: t('xuat_bao_cao'), url: '#', navigate: false }]} />

                <Grid container spacing={1.5}>
                    {/* START ___________________   */}
                    {/*  ___________________  filter ___________________*/}
                    <Grid item xl={3} md={3} sm={6} style={{ width: '100%' }}>
                        <DatePickerValue label={t('start_day')} valueChange={startDay} getValue={setstartDay} />
                    </Grid>
                    <Grid item xl={3} md={3} sm={6} style={{ width: '100%' }}>
                        <DatePickerValue label={t('to_day')} valueChange={toDay} getValue={settoDay} />
                    </Grid>
                    <Grid item xl={6} md={6} sm={12} sx={{ display: 'flex', alignItems: 'center' }}>
                        <FormControl>
                            <RadioGroup
                                row
                                aria-labelledby="demo-row-radio-buttons-group-label"
                                name="row-radio-buttons-group"
                                value={selectedValue}
                                onChange={handleChange}
                            >
                                <FormControlLabel value="one" control={<Radio />} label={t('statistical_1_month')} />
                                <FormControlLabel value="two" control={<Radio />} label={t('statistical_2_month')} />
                            </RadioGroup>
                        </FormControl>
                    </Grid>
                    {/*  ___________________  filter ___________________*/}
                    {/* END ___________________   */}

                    {/* START ___________________   */}
                    {/*  ___________________  Chi phí tổng ___________________*/}
                    <ExpenseTotal
                        department={department}
                        selectedValue={selectedValue}
                        toDay={toDay}
                        startDay={startDay}
                        tableRef={tableRef}
                    />
                    {/*  ___________________  Chi phí tổng ___________________*/}
                    {/* END ___________________   */}

                    <Grid item xs={12} sm={12} md={12} xl={12} style={{ width: '100%', paddingTop: '24px' }}>
                        <SelectObjectDepartment
                            disabled={userRef.current?.group_user === '3'}
                            label={t('department')}
                            valueSelect={department}
                            getValue={setDepartment}
                        />
                    </Grid>

                    {/* START ___________________   */}
                    {/*  ___________________  Số lượng tổng ___________________*/}
                    {department && (
                        <AmountTotal
                            department={department}
                            selectedValue={selectedValue}
                            toDay={toDay}
                            startDay={startDay}
                        />
                    )}
                    {/*  ___________________  Số lượng tổng ___________________*/}
                    {/* END ___________________   */}

                    <ExpenseAndAmountByTime />
                </Grid>
            </Container>
        </>
    );
}
